module.exports = __webpack_public_path__ + "static/media/pen-light-grey.f1648f68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/pen-light-grey.svg
// module id = 1956
// module chunks = 0